import { MemberService } from './../../Services/member.service';
import { Component, OnInit } from '@angular/core';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
import { GeneralSettingsService } from '../../Services/general-settings.service';

@Component({
  selector: 'app-new-member-form',
  template: require('./new-member-form.component.html'),
  styles: [require('./new-member-form.component.css')]
})
export class NewMemberFormComponent implements OnInit {
  member: any = {};
  selectedDate: any;
  bankAccount:string= "";
  subscriptionFee:string= "";
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(private memberService:MemberService,private router: Router, private generalSettingsService:GeneralSettingsService ) { }

  ngOnInit() {
    this.generalSettingsService.getBankAccount().subscribe( (res:any)=>{
      if (res.status == 200){
        this.bankAccount = res.value.bankAccount;
      }
    })
    this.generalSettingsService.getSubscriptionFee().subscribe( (res:any)=>{
      if (res.status == 200){
        this.subscriptionFee = res.value.subscriptionFee;
      }
    })
  }

  submit(){
    // console.log("Submit")
    // console.log(this.member);
    var checkedAll:boolean = false;
    if (this.member.rule1 == true && this.member.rule2 == true && this.member.rule3 == true && this.member.rule4 == true && this.member.rule5 == true){
      checkedAll = true;
    }

    var memberRequest = {
      birthday: String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day),
      firstName: this.member.firstName,
      lastName: this.member.lastName,
      streetName: this.member.streetName,
      houseNr: this.member.houseNr,
      postalCode: this.member.postalCode,
      community: this.member.community,
      telephoneNr: this.member.telephoneNr,
      cellPhoneNr: this.member.cellPhoneNr,
      email: this.member.email, 
      acceptedAllChecks: checkedAll   ,
      gender: this.member.gender 
    }
    // newMemberRequest
    // console.log(memberRequest);
    
    this.memberService.newMemberRequest(memberRequest).subscribe(status => {
      if (status == 200){
        Swal.fire({
          title: 'Welkom!',
          type: 'success',
          html:
            'We hebben je inschrijving ontvangen.<br>' +
            'Kijk op onze website naar de kalender, we verwachten je!',
            
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        }).then(() => {
          this.router.navigate(['/home']);
        })
      }
    })
    
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/new-member-form/new-member-form.component.ts